export default __webpack_public_path__ + "static/media/d3.cb123817.jpg";